module.exports = __webpack_public_path__ + "static/images/casbg.130159fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/casbg.png
// module id = 726
// module chunks = 0